import ajax from '@/utils/request'

/**
 * TopicService
 * @module service/Topic
 */
export default {
    /**
   * 通过频道id 查询频道
   * @see https://yapi.geekbang.org/project/116/interface/api/19759
   * @param {Array} ids
   */
  getTopicByIds (ids) {
    return ajax({
      url: 'public/v1/topic/get_list_by_ids',
      data: {
        ids: ids
      }
    }).then(res => {
      return res.list
    })
  },
  /**
   * 批量关注频道
   * @param {Array} data  关注的频道id  数组
   */
  batchSub (data) {
    return ajax({
      url: 'public/v1/subtopic/batchSub',
      data: {
        ids: data
      }
    })
  }
}
